import { z } from 'zod'

export const schema = z.object({
  notice: z.string(),
})
export type FormValues = z.infer<typeof schema>
export const FORM_ID = 'edit-notice-dialog-form'
